import { byWindowAction, debounce, sendGoogleEvent } from 'html/include/pw/_common/utils';

const SLIDER_WRAPPER_CLASS_JS = '.js-ao-clp-slider';
const LEFT_ARROW_CLASS_JS = '.js-ao-clp-slider__slider-arrow--left';
const RIGHT_ARROW_CLASS_JS = '.js-ao-clp-slider__slider-arrow--right';
const ITEMS_LIST_CLASS_JS = '.js-ao-clp-slider__items-list';
const NAVIGATION_CONTAINER_CLASS_JS = 'js-ao-clp-slider__navigation-dots-list';
const NAVIGATION_DOT_CLASS_JS = 'js-ao-clp-slider__navigation-dot';
const NAVIGATION_DOT_CLASS = 'ao-clp-slider__navigation-dot';
const ACTIVE_NAVIGATION_DOT_CLASS_JS = 'js-ao-clp-slider__navigation-dot--active';
const ACTIVE_NAVIGATION_DOT_CLASS = 'ao-clp-slider__navigation-dot--active';
const EVENT_CATEGORY = 'Slider component';
const TOUR_LINK_JS = '.js-ao-clp-tours-slider-items__item-anchor';

export default function AOClpSlider(sliders) {
  const numberOfRemainingRightItems = (slider) => {
    const itemsPerSlide = Math.floor(100 / slider.itemWidthInPercent);
    return slider.numberOfItems - (slider.itemsScrolled + itemsPerSlide);
  };

  const updateActiveDot = (slider) => {
    const itemsPerSlide = Math.floor(100 / slider.itemWidthInPercent);
    const numberOfDots = Math.ceil(slider.numberOfItems / itemsPerSlide);

    if (numberOfDots === 1) return;

    const currentSlideIndex = Math.ceil(slider.itemsScrolled / itemsPerSlide);
    slider.$activeDot.removeClass(`${ACTIVE_NAVIGATION_DOT_CLASS_JS} ${ACTIVE_NAVIGATION_DOT_CLASS}`);
    slider.$activeDot = slider.$navigationDots.eq(currentSlideIndex);
    slider.$activeDot.addClass(`${ACTIVE_NAVIGATION_DOT_CLASS_JS} ${ACTIVE_NAVIGATION_DOT_CLASS}`);
  };

  const getSliderInfoForOnClick = ($arrow) => {
    const sliderId = $arrow.data('sliderId');
    const slider = sliders[sliderId];

    return {
      sliderId,
      slider,
      itemsPerSlide: Math.floor(100 / slider.itemWidthInPercent),
      currentlyTranslated: Math.ceil(slider.itemsScrolled * slider.itemWidthInPercent),
    };
  };

  const navigationClick = (event) => {
    const $clickedDot = $(event.currentTarget);

    const sliderId = $clickedDot.parent().data('sliderId');
    const slider = sliders[sliderId];

    const clickedDotIndex = $clickedDot.index();
    const currentIndex = slider.$activeDot.index();

    if (clickedDotIndex === currentIndex) {
      return;
    }

    const slideToRight = currentIndex < clickedDotIndex;
    const slideToLeft = clickedDotIndex < currentIndex;

    const indexDifference = Math.abs(clickedDotIndex - currentIndex);
    for (let i = 0; i < indexDifference; i += 1) {
      if (slideToRight) {
        slider.$rightArrow.click();
      } else if (slideToLeft) {
        slider.$leftArrow.click();
      }
    }
  };

  const translateSlider = (slider, translateBy) => {
    if (translateBy > 0) {
      slider.$firstElement.css('margin-left', `-${translateBy}%`);
    } else {
      slider.$firstElement.css('margin-left', '0');
    }
  };

  const updateArrowVisibility = (slider, itemsPerSlide) => {
    const sliderIsAtEnd = slider.numberOfItems
              === (slider.itemsScrolled + itemsPerSlide) || slider.numberOfItems <= itemsPerSlide;
    const sliderIsAtBeginning = slider.itemsScrolled === 0;

    if (sliderIsAtEnd) {
      slider.$rightArrow.hide();
    } else {
      slider.$rightArrow.show();
    }

    if (sliderIsAtBeginning) {
      slider.$leftArrow.hide();
    } else {
      slider.$leftArrow.show();
    }
  };

  const performSlidingRoutine = (slider, translateBy, itemsPerSlide) => {
    translateSlider(slider, translateBy);
    updateArrowVisibility(slider, itemsPerSlide);
    updateActiveDot(slider);
  };

  const setDataIds = (sliderId, slider) => {
    slider.$navigationContainer.data('sliderId', sliderId);
    slider.$leftArrow.data('sliderId', sliderId);
    slider.$rightArrow.data('sliderId', sliderId);
  };

  const rightArrowClick = (event) => {
    const $clickedArrow = $(event.currentTarget);

    const clickedSlider = getSliderInfoForOnClick($clickedArrow);
    const numberOfRemainingRightItemsVar = numberOfRemainingRightItems(clickedSlider.slider);

    let translateBy = 0;
    const slideOneFullWidth = numberOfRemainingRightItemsVar > clickedSlider.itemsPerSlide;

    if (slideOneFullWidth) {
      clickedSlider.slider.itemsScrolled += clickedSlider.itemsPerSlide;
      translateBy = clickedSlider.currentlyTranslated + 100;
    } else {
      clickedSlider.slider.itemsScrolled += numberOfRemainingRightItemsVar;
      translateBy = clickedSlider.currentlyTranslated
                  + (Math.ceil(numberOfRemainingRightItemsVar * clickedSlider.slider.itemWidthInPercent));
    }

    performSlidingRoutine(clickedSlider.slider, translateBy, clickedSlider.itemsPerSlide);
  };

  const leftArrowClick = (event) => {
    const $clickedArrow = $(event.currentTarget);

    const clickedSlider = getSliderInfoForOnClick($clickedArrow);
    const numberOfRemainingLeftItems = clickedSlider.slider.itemsScrolled;

    let translateBy = 0;
    const slideOneFullWidth = numberOfRemainingLeftItems > clickedSlider.itemsPerSlide;

    if (slideOneFullWidth) {
      clickedSlider.slider.itemsScrolled -= clickedSlider.itemsPerSlide;
      translateBy = clickedSlider.currentlyTranslated - 100;
    } else {
      clickedSlider.slider.itemsScrolled -= numberOfRemainingLeftItems;
      translateBy = 0;
    }

    performSlidingRoutine(clickedSlider.slider, translateBy, clickedSlider.itemsPerSlide);
  };

  const attachEventListeners = (slider) => {
    slider.$rightArrow.on('click', rightArrowClick);
    slider.$leftArrow.on('click', leftArrowClick);
    slider.$navigationContainer.on('click', `.${NAVIGATION_DOT_CLASS_JS}`, navigationClick);
  };
  const appendNavigationDots = (slider) => {
    const itemsPerSlide = Math.floor(100 / slider.itemWidthInPercent);
    const numberOfDots = Math.ceil(slider.numberOfItems / itemsPerSlide);

    let activeDotIndex = 0;
    if (slider.itemsScrolled !== 0) {
      activeDotIndex = Math.ceil(slider.itemsScrolled / itemsPerSlide);
    }

    if (slider.$navigationDots) {
      slider.$navigationDots.remove();
    }

    if (numberOfDots === 1) {
      return;
    }

    let htmlElements = '';
    for (let i = 0; i < numberOfDots; i += 1) {
      if (i === activeDotIndex) {
        htmlElements += `<li class="${NAVIGATION_DOT_CLASS} ${ACTIVE_NAVIGATION_DOT_CLASS} ${NAVIGATION_DOT_CLASS_JS} ${ACTIVE_NAVIGATION_DOT_CLASS_JS}"></li>`;
      } else {
        htmlElements += `<li class="${NAVIGATION_DOT_CLASS} ${NAVIGATION_DOT_CLASS_JS}"></li>`;
      }
    }

    slider.$navigationContainer.append(htmlElements);
    slider.$navigationDots = slider.$navigationContainer.find(`.${NAVIGATION_DOT_CLASS_JS}`);
    slider.$activeDot = slider.$navigationContainer.find(`.${ACTIVE_NAVIGATION_DOT_CLASS_JS}`);
  };

  const updateSlider = (slider) => {
    const sliderWidth = slider.$itemsList.width();
    const itemWidth = slider.$itemsList.children().first().width();
    const newItemWidthInPercent = Math.round((itemWidth / sliderWidth) * 100);

    const itemWidthChanged = newItemWidthInPercent !== slider.itemWidthInPercent;

    if (!itemWidthChanged) return;

    const newItemsCountPerSlide = Math.floor(100 / newItemWidthInPercent);
    const sliderIsExpanding = newItemWidthInPercent < slider.itemWidthInPercent;

    const itemsDivisibleByNewCount = slider.numberOfItems % newItemsCountPerSlide === 0;
    const itemAtLastSlideInNewWidth = (slider.numberOfItems - slider.itemsScrolled)
              <= newItemsCountPerSlide;

    slider.itemWidthInPercent = newItemWidthInPercent;
    if (sliderIsExpanding && itemsDivisibleByNewCount) {
      const itemSliderIndexInNewWidth = Math.floor(slider.itemsScrolled / newItemsCountPerSlide);
      slider.itemsScrolled = itemSliderIndexInNewWidth * newItemsCountPerSlide;
    } else if (sliderIsExpanding && itemAtLastSlideInNewWidth) {
      const updatedItemsScrolled = slider.numberOfItems - newItemsCountPerSlide;
      slider.itemsScrolled = (updatedItemsScrolled > 0) ? updatedItemsScrolled : 0;
    }

    const translateBy = (slider.itemsScrolled * slider.itemWidthInPercent);
    translateSlider(slider, translateBy);
    appendNavigationDots(slider);
    updateArrowVisibility(slider, newItemsCountPerSlide);
  };

  const onResize = debounce(() => {
    for (let i = 0; i < sliders.length; i += 1) {
      const slider = sliders[i];
      updateSlider(slider);
    }
  }, 250);

  const initiateTracking = () => {
    $(TOUR_LINK_JS).on('click', (event) => {
      event.stopPropagation();
      const $clickedElement = $(event.currentTarget);
      const $clickedElementItem = $clickedElement.closest('.js-ao-clp-tours-slider-items__item');
      const clickedElementLink = $clickedElement.attr('href');
      const eventCategory = $clickedElement.closest('.js-ao-clp-slider__items-list').data('category');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) return;

      sendGoogleEvent(
        eventCategory || EVENT_CATEGORY,
        clickedElementLink,
        `Index: ${$clickedElementItem.index() + 1}`,
      );
    });
  };

  const initiateSlider = (index, element) => {
    const $sliderWrapper = $(element);

    if ($sliderWrapper.data('slider-initiated')) return;

    const sliderId = sliders.length;
    const slider = {};

    slider.$itemsList = $sliderWrapper.find(ITEMS_LIST_CLASS_JS);

    const sliderWidth = slider.$itemsList.width();
    const itemWidth = slider.$itemsList.children().first().width();
    const itemWidthInPercent = Math.round((itemWidth / sliderWidth) * 100);
    const itemsCountPerSlide = Math.floor(100 / itemWidthInPercent);

    slider.$sliderWrapper = $sliderWrapper;
    slider.$leftArrow = $sliderWrapper.find(LEFT_ARROW_CLASS_JS);
    slider.$rightArrow = $sliderWrapper.find(RIGHT_ARROW_CLASS_JS);
    slider.$firstElement = slider.$itemsList.children().first();
    slider.numberOfItems = slider.$itemsList.children().length;
    slider.itemWidthInPercent = itemWidthInPercent;
    slider.itemsScrolled = 0;
    slider.$navigationContainer = $sliderWrapper.find(`.${NAVIGATION_CONTAINER_CLASS_JS}`);
    slider.$activeDot = null;
    slider.$navigationDots = null;

    updateArrowVisibility(slider, itemsCountPerSlide);

    appendNavigationDots(slider);
    setDataIds(sliderId, slider);
    attachEventListeners(slider);

    sliders.push(slider);
    $sliderWrapper.data('slider-initiated', 'true');
  };

  const initiate = () => {
    const $sliderContainers = $(SLIDER_WRAPPER_CLASS_JS);
    const isTouchDevice = $('body').hasClass('touch');

    if ($sliderContainers <= 0 || isTouchDevice) return;

    $sliderContainers.each(initiateSlider);
    byWindowAction(['resize'], onResize);
    initiateTracking();
  };

  return { initiate, initiateSlider };
}
